import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initGA4 } from './analytics';

// Initialize Google Analytics 4
initGA4();

// Prevent pinch-zoom (iOS requires JavaScript, CSS alone doesn't work)
const preventZoom = (e: TouchEvent) => e.touches.length > 1 && e.preventDefault();
document.addEventListener('gesturestart', (e) => e.preventDefault());
document.addEventListener('touchstart', preventZoom, { passive: false });
document.addEventListener('touchmove', preventZoom, { passive: false });

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
